<div class="col-lg-12 d-flex">
    <div class="arrow-left" (click)="back()">
        <img src="../../../assets/images/arrow-left.png" />
    </div>
    <div class="tptxt-gbdpg header-cnt">
        <h4>{{pageTitle}}</h4>
    </div>
</div>